
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Product from "../pages/product/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Product />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
